// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchButton_button__JjPHN","activated":"SearchButton_activated__1aAeo"};